import { memo, useCallback, useEffect, useState } from "react";
import Breadcrumb from "components/shared/breadcrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import Form from "../form/form";
import { useSearchParams } from "react-router-dom";
import MasterAPI from "service/master";
import { toast } from "react-toastify";

const Edit = props => {
    const { pageData, id } = props;
    const [breadcrumb, setBreadcrumb] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [goSubmit, setGoSubmit] = useState(0);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [defaultValues, setDefaultValues] = useState({});
    const [dataIsDraft, setDataIsDraft] = useState(false);
    const [defaultCats, setDefaultCats] = useState([]);
    const navigate = useNavigate();
    const [targetCategory, setTargetCategory] = useState("");
    const [groupType, setGroupType] = useState(null);

    useEffect(() => {
        if (pageData.breadcrumb) {
            setBreadcrumb([
                ...pageData.breadcrumb,
                { title: "ویرایش" }
            ]);
        }
        // eslint-disable-next-line
    }, [pageData])

    useEffect(() => {
        defaultValueFetcher();
        // eslint-disable-next-line
    }, [])

    const defaultValueFetcher = async () => {
        try {
            let url = pageData.get_url;
            url = url.replace(":id", id);
            url = url.replace(":form_id", searchParams.get("form_id"));

            const res = await MasterAPI({
                url,
                method: "GET"
            });

            if (res.data) {
                const { data } = res;

                setGroupType(res.data.group_type);
                if (res.draft) {
                    setDataIsDraft(true);
                    setDefaultValues(res.draft.content.fields);
                } else if (data.fields)
                    setDefaultValues(res.data.fields);

                if (res.draft)
                    setDefaultCats(res.draft.content.categories);
                else if (data.categories?.length)
                    setDefaultCats(data.categories);

                setTargetCategory(data.target_category);
            } else
                throw Object.assign(new Error("no fields"), { code: 402 });
        } catch (e) {
            toast.error(e.message);
        }
    }

    const getPreviousRoute = () => {
        const splitedRoute = location.pathname.split("/");
        splitedRoute.pop();

        return `${splitedRoute.join("/")}?form_id=${searchParams.get("form_id")}`;
    }

    const setParentLoading = useCallback(value => {
        setSubmitLoading(value);
        // eslint-disable-next-line
    }, [])

    const submitHandler = () => {
        setGoSubmit(prev => prev + 1);
    }

    const doneCallback = useCallback(() => {
        navigate(getPreviousRoute());
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-5 options-bar">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">{pageData.title}</h1>
                    <Breadcrumb data={breadcrumb} />
                </div>

                <div className="flex">
                    <Link to={getPreviousRoute()} className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center">
                        <i className="fa-regular fa-arrow-right"></i>
                    </Link>

                    <button
                        className={`bg-primary-100 hover:bg-primary-200 px-7 transition-colors text-white rounded-md fit-center text-sm h-10 relative overflow-hidden${submitLoading ? " cursor-progress" : ""}`}
                        onClick={submitHandler}
                    >
                        <i className="fa-light fa-pen-to-square ml-2"></i>
                        ثبت تغییرات

                        <CSSTransition in={submitLoading} timeout={200} unmountOnExit={true}>
                            <span className="pos-cover bg-primary-200 fit-center anim-c4">
                                <i className="fa-solid fa-spinner spin"></i>
                            </span>
                        </CSSTransition>
                    </button>
                </div>
            </div>

            <div className="wrap-box tp-22">
                <Form
                    id={id}
                    formId={searchParams.get("form_id")}
                    setParentLoading={setParentLoading}
                    goSubmit={goSubmit}
                    defaultValues={defaultValues}
                    draftLabel={dataIsDraft}
                    mode="edit"
                    doneCallback={doneCallback}
                    defaultCats={defaultCats}
                    targetCategory={targetCategory}
                    groupType={groupType}
                />
            </div>
        </>
    )
}

export default memo(Edit);